import { render, staticRenderFns } from "./PayrollReport.vue?vue&type=template&id=5bcc343e"
import script from "./PayrollReport.vue?vue&type=script&lang=js"
export * from "./PayrollReport.vue?vue&type=script&lang=js"
import style0 from "./PayrollReport.vue?vue&type=style&index=0&id=5bcc343e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports